declare namespace $ {

	type $mol_text__text_shm_showcase_group_1 = $mol_type_enforce<
		ReturnType< $shm_showcase_group['title'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_showcase_group_2 = $mol_type_enforce<
		ReturnType< $shm_showcase_group['content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_showcase_group extends $mol_list {
		Label( ): $mol_text
		content( ): readonly($mol_view)[]
		Content( ): $mol_view
		rows( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=group.view.tree.d.ts.map